"use client"

import { memo } from "react"

import { useAppDispatch, useAppSelector } from "@/redux/hooks"

import { applyFilter, resetFilter } from "../../model/catalogSlice"
import type { TFilterExtraComponent } from "../../model/filterTypes"

interface IFilterExtraProps {
    Component: TFilterExtraComponent
}

export const FilterExtra = memo(function FilterExtra({ Component }: IFilterExtraProps) {
    const dispatch = useAppDispatch()

    const { filterCount, editableFilterCount } = useAppSelector((state) => state.catalog)

    return (
        <Component
            applyFilter={() => dispatch(applyFilter())}
            resetFilter={() => dispatch(resetFilter())}
            filterCount={filterCount}
            editableFilterCount={editableFilterCount}
        />
    )
})
